import { Box } from '../box';
import { Sort } from '../sort.data';
import { BoxesStatistics } from '../boxes-statistics';
import { BoxPageRequest } from '../box-page-request.data';
import { Partner } from '../partner';
import { PartnerLightData } from '../partner-light-data';

export interface BoxState {
  boxes: Box[];
  pageRequest: BoxPageRequest;
  loading: boolean;
  boxesStatistics: BoxesStatistics;
  statisticsLoading: boolean;
  managers: PartnerLightData[];
  saving: boolean;
}

export const initialBoxState: BoxState = {
  boxes: [],
  pageRequest: {
    page: 0,
    size: 20,
    sort: {} as Sort,
    searchText: '',
  },
  loading: true,
  boxesStatistics: {
    connectedCount: 0,
    totalCount: 0,
  },
  statisticsLoading: true,
  managers: [],
  saving: false,
};
